//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';

//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------

const translationsInit = {
};

export const book_pages_translations = (state = translationsInit, action) => {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.page_translations.set_book_translations:
            return {
                ...state,
                [payload.book_id]: payload.data,
            };

        case ActionTypes.page_translations.update_book_translations:
            return {
                ...state,
                [payload.book_id]: state[payload.book_id]
                    ? state[payload.book_id].some(k => k.id === payload.data.id)
                        ? state[payload.book_id].map(k => (k.id === payload.data.id ? payload.data : k))
                        : [...state[payload.book_id], payload.data]
                    : [payload.data],
            };

        case ActionTypes.page_translations.remove_page_translations:
            return {
                ...state,
                [payload.book_id]: state[payload.book_id]?.filter(k => k.page !== payload.page_id) || [],
            };

        case ActionTypes.page_translations.clear_book_translations:
            return translationsInit;

        default:
            return state;
    }
};


const book_grammar_contentInit = [];

export const book_grammar_content = (state = book_grammar_contentInit, action) => {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.grammar_content.set_book_grammar_content:
            return payload;

        case ActionTypes.grammar_content.update_book_grammar_content:
            return state.some(item => item.id === payload.id)
                ? state.map(item => (item.id === payload.id ? payload : item))
                : [...state, payload];

        case ActionTypes.grammar_content.remove_book_grammar_content:
            return state.filter(item => item.id !== payload.id);

        case ActionTypes.grammar_content.clear_book_grammar_content:
            return book_grammar_contentInit;

        default:
            return state;
    }
};


const book_vocab_contentInit = [];

export const book_vocab_content = (state = book_vocab_contentInit, action) => {
    const { type, payload } = action;

    switch (type) {
        case ActionTypes.vocab_content.set_book_vocab_content:
            return payload;

        case ActionTypes.vocab_content.update_book_vocab_content:
            return state.some(item => item.id === payload.id)
                ? state.map(item => (item.id === payload.id ? payload : item))
                : [...state, payload];

        case ActionTypes.vocab_content.remove_book_vocab_content:
            return state.filter(item => item.id !== payload.id);

        case ActionTypes.vocab_content.clear_book_vocab_content:
            return book_vocab_contentInit;

        default:
            return state;
    }
};


